import { useState } from 'react'

interface SelectedLead {
  name: string
  data: number[]
  highlight: boolean
  avgWave?: Record<string, number>
}

/**
 * Hook para gerenciar o estado do modal de visualização ampliada
 * Controla abertura, fechamento e dados da derivação selecionada
 */
export const useECGModal = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedLead, setSelectedLead] = useState<SelectedLead | null>(null)

  const openModal = (
    leadName: string,
    data: number[],
    highlight: boolean,
    avgWave?: Record<string, number>
  ) => {
    setSelectedLead({ name: leadName, data, highlight, avgWave })
    setModalOpen(true)
  }

  const closeModal = () => {
    setModalOpen(false)
    setSelectedLead(null)
  }

  return {
    modalOpen,
    selectedLead,
    openModal,
    closeModal
  }
}
